const testimonials = [
  {
    quote: "J'ai traversé l'après-carrière sans filet. Aujourd'hui 5 salles, 2M€ investis. Ce réseau, j'aurais voulu qu'il existe quand j'en avais besoin.",
    name: 'Moses Mubarak',
    role: 'Ancien sportif pro · Entrepreneur',
    badge: 'Ambassadeur',
    avatar: 'https://public.readdy.ai/ai/img_res/2ae0b05dc716d07728498026d9a7b29b.jpg',
  },
  {
    quote: "Le terrain ne ment pas. Le business non plus. Ici on construit pour vrai. Heureux de faire partie de cette aventure avec vous.",
    name: 'Terence Pinto',
    role: 'Ancien sportif · Ambassadeur AD.NOVA.PRO',
    badge: 'Ambassadeur',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20athletic%20man%20in%20his%2030s%20determined%20look%20confident%20smile%20dark%20background%20minimal%20dramatic%20lighting%20professional%20headshot&width=150&height=150&seq=terence1&orientation=squarish',
  },
  {
    quote: "En 6 mois avec AD.NOVA.PRO, j'ai structuré mon projet, trouvé mon comptable et rencontré mes deux premiers clients. Ce que je n'aurais pas fait seul en 2 ans.",
    name: 'Karim Benali',
    role: 'Ancien footballeur pro · En reconversion',
    badge: 'Membre',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20athletic%20north%20african%20man%20in%20his%2030s%20confident%20look%20business%20casual%20clean%20background%20studio%20lighting&width=150&height=150&seq=karim1&orientation=squarish',
  },
];

const TestimonialsSection = () => {
  return (
    <section className="bg-[#0D1228] py-24 px-6 border-y border-white/[0.07]">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#C9A227]/10 border border-[#C9A227]/20 rounded-full mb-5">
            <i className="ri-chat-quote-line text-[#C9A227] text-xs"></i>
            <span className="text-[#C9A227] text-xs font-semibold tracking-widest uppercase">Ils témoignent</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            Des vraies transitions,<br />
            <span className="text-[#C9A227]">des vraies personnes</span>
          </h2>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#080C1E] border border-white/[0.07] rounded-2xl p-6 flex flex-col gap-5">
              <i className="ri-double-quotes-l text-3xl text-[#C9A227]/30"></i>
              <p className="text-white/70 text-sm leading-relaxed flex-1 italic">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/[0.07]">
                <div className="w-11 h-11 rounded-full overflow-hidden ring-2 ring-[#C9A227]/20 flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{t.name}</p>
                  <p className="text-white/30 text-xs">{t.role}</p>
                </div>
                <span className="ml-auto px-2 py-0.5 bg-[#C9A227]/10 border border-[#C9A227]/20 rounded-full text-[#C9A227] text-[9px] font-bold whitespace-nowrap">
                  {t.badge}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
